// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#auth-redirect-container{display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1 0 auto}#auth-redirect-container h1{margin-bottom:1rem}#auth-redirect-container i{font-size:3rem;margin-top:2rem}", ""]);
// Exports
module.exports = exports;
